module.exports = __webpack_public_path__ + "fonts/MING_MSCS.7200ec89.woff";